import { render, staticRenderFns } from "./DragAndDropMultipleLists.vue?vue&type=template&id=2de29b2b&"
import script from "./DragAndDropMultipleLists.vue?vue&type=script&lang=js&"
export * from "./DragAndDropMultipleLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports